var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.686 3.977V1.565H5.067v2.412h13.619zm0 7.353V6.091H5.067v5.239h13.619zM18.426.3c.49 0 .958.194 1.304.54.345.344.54.811.54 1.299v9.191a1.836 1.836 0 01-1.843 1.838H5.528a1.836 1.836 0 01-1.843-1.838V2.139c0-1.02.82-1.838 1.843-1.838h12.899zM1.267 15.467h14.397v1.379H1.843c-.489 0-.958-.194-1.303-.539a1.836 1.836 0 01-.54-1.3V4.897h1.267v10.57z",
    fill: "currentColor"
  })));
}

export default SvgCardIcon;